module.exports = __webpack_public_path__ + "static/media/home_icon.f9d72106.svg";